var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSudoku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.5 17.89h37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 30.11h37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.11 5.5v37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.89 5.5v37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.82 22.76a2.52 2.52 0 0 0 -2.65-2.51 2.61 2.61 0 0 0 -2.38 2.66v2.33a2.52 2.52 0 0 0 2.52 2.51 2.52 2.52 0 0 0 2.51-2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.48 32.85v5a2.52 2.52 0 0 0 2.52 2.5 2.52 2.52 0 0 0 2.52-2.51v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.48 7v5a2.51 2.51 0 0 0 2.52 2.45 2.51 2.51 0 0 0 2.52-2.51v-4.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.49 27.75v-7.5h1.27a3.75 3.75 0 0 1 3.75 3.75 3.75 3.75 0 0 1 -3.75 3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.2 7h-3.14a1.88 1.88 0 0 0 -1.88 1.83 1.88 1.88 0 0 0 1.88 1.87h.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.69 10.7h.64a1.87 1.87 0 0 1 1.87 1.88 1.87 1.87 0 0 1 -1.87 1.87h-3.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.83 33.03v7.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.8 36.77 2.76-3.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.8 36.77 2.76 3.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.8 36.77h-.97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSudoku);
export default __webpack_public_path__ + "static/media/sudoku.31595c4d5dd58d986fc06c2e84c12687.svg";
export { ForwardRef as ReactComponent };